import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ResetPasswordService } from "@app/core/user/domain/services/reset-password.service";
import { ResetPasswordWS } from "@app/core/user/data/network/reset-password-ws.service";

@Injectable()
export class ResetPasswordActionService implements ResetPasswordService {
  constructor(private userWS: ResetPasswordWS) {}

  execute(email: string): Observable<void> {
    return this.userWS.execute(email);
  }
}
